import { useTranslation } from 'contexts/Localization'
import { Flex, Text } from 'vvs-uikit'
import { QuestSymbol } from 'state/vvsgotchi/models/quest'
import useGotchiQuests from 'state/vvsgotchi/hooks/useGotchiQuests'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import QuestButton from '../QuestButton'

const QuestOnboardSection = () => {
  const { t } = useTranslation()
  const { findQuest } = useGotchiQuests()
  const adoptQuest = findQuest(QuestSymbol.ADOPT)
  const teamUpQuest = findQuest(QuestSymbol.TEAM_UP)

  return (
    <>
      <Flex m={3}>
        <Flex mt={2} flexDirection="column" flex="1">
          <Text color="black" fontSize="20px" bold as="h3">
            {t('Getting on-board now!')}
          </Text>
          <Text color="black" width="188px" fontSize="13px">
            {t('Complete below 2 on-boarding tasks to unlock other quests')}
          </Text>
        </Flex>
        <PixelatedImage
          src="/images/vvsGotchi/quest_onboard.png"
          alt="onboard quest background"
          width="100px"
          alignSelf="end"
        />
      </Flex>
      <Flex px={3} pt={3} gap="1rem" justifyContent="space-evenly">
        {adoptQuest && <QuestButton quest={adoptQuest} isOnboardButton title={t('Step 1: Adopt')} />}
        {teamUpQuest && <QuestButton quest={teamUpQuest} isOnboardButton title={t('Step 2: Team Up')} />}
      </Flex>
    </>
  )
}

export default QuestOnboardSection
